module.exports = __webpack_public_path__ + "img/title1.5dcfd195.png";